import { jsx as _jsx } from "@emotion/react/jsx-runtime";
import { useCallback } from 'react';
import { createRequestMttStagingToggleReadyOutbound } from '../../api/outbound/mttStagingOutbounds';
import { CheckboxButton } from '../../components/checkboxButton';
import { useSocketSend } from '../../context/webSocket/webSocketContext';
import { useAppDispatch, useAppSelector } from '../../redux/store';
import { validateSupportedPokerVariantIdOrShowError } from '../../utils/pokerVariantUtils';
export const MttStagingReadyButtonContainer = () => {
    const dispatch = useAppDispatch();
    const socketSend = useSocketSend();
    const isMttReady = useAppSelector((state) => state.mttStaging.isMttReady);
    const mttStagingTables = useAppSelector((state) => state.mttStaging.mttStagingTables);
    const isAllInGame = false; // MTTs cannot be created as all-in games, so this is always false.
    const onClick = useCallback(() => {
        if (validateSupportedPokerVariantIdOrShowError(isAllInGame, dispatch)) {
            socketSend(createRequestMttStagingToggleReadyOutbound(false));
        }
    }, [dispatch, isAllInGame, socketSend]);
    if (mttStagingTables.length) {
        // If tables exist, game is in progress or starting, so it cannot be joined.
        return null;
    }
    return (_jsx(CheckboxButton, { label: isMttReady ? 'Ready' : 'Join Game', ariaLabel: 'Toggle Ready', isChecked: isMttReady, onClick: onClick, checkedMaterialColor: 'primary', uncheckedMaterialColor: 'secondary' }));
};
